import React from 'react';
import { Search01Icon, FileExportIcon, PlusSignIcon, CircleIcon } from 'hugeicons-react';
import '../../assets/css/components/common/empty-state.css';

const EmptyState = ({ 
  icon = 'default', 
  title = 'No data found', 
  message = 'There is no data to display at the moment.',
  suggestion = null,
  actionButton = null 
}) => {
  const getIcon = () => {
    const iconProps = { size: 64, color: '#9CA3AF' };
    
    switch (icon) {
      case 'target':
        return <FileExportIcon {...iconProps} />;
      case 'measure':
        return <Search01Icon {...iconProps} />;
      case 'user':
        return <PlusSignIcon {...iconProps} />;
      case 'notification':
        return <CircleIcon {...iconProps} />;
      default:
        return <FileExportIcon {...iconProps} />;
    }
  };

  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        {getIcon()}
      </div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-message">{message}</p>
      {suggestion && (
        <p className="empty-state-suggestion">{suggestion}</p>
      )}
      {actionButton && (
        <div className="empty-state-action">
          {actionButton}
        </div>
      )}
    </div>
  );
};

export default EmptyState;

